import React, { useEffect, useState } from "react";
import { Option } from "react-multi-select-component";
import { toast } from "react-toastify";
import ImageUpload from "src/Components/GlobalComponents/ImageUplaod";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
import SimpleInput from "src/Components/SimpleInput";
import httpRequest from "src/helpers/httpRequest";
import { ISubCategory } from "src/types/GlobalInterfaces";

interface IProps {
  onSuccess: () => void;
  isEdit: ISubCategory | null;
  getLoader: boolean;
  allMainCategory: { value: string; label: string }[];
}

interface IObjInterface {
  mainCategoryId: string;
  subCategoryName: string;
  subCategoryBanner: File | null | string;
  subCategoryImage: File | null | string;
  description: string;
}

const UpsertSubCategory: React.FC<IProps> = ({
  onSuccess = () => {},
  isEdit = null,
  getLoader = false,
  allMainCategory = [],
}) => {
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [payload, setPayload] = useState<IObjInterface>({
    mainCategoryId: "",
    subCategoryName: "",
    subCategoryBanner: null,
    subCategoryImage: null,
    description: "",
  });

  const handleSubmit = async () => {
    const {
      mainCategoryId,
      subCategoryName,
      subCategoryBanner,
      subCategoryImage,
      description,
    } = payload;
    if (!subCategoryBanner) {
      toast("Please upload a banner image.", { type: "error" });
    } else if (!subCategoryImage) {
      toast("Please upload a category image.", { type: "error" });
    } else if (!subCategoryName) {
      toast("Please enter the category name.", { type: "error" });
    } else if (!mainCategoryId) {
      toast("Please select a main category.", { type: "error" });
    } else {
      setIsLoader(true);
      const formData = new FormData();
      formData.append("mainCategoryId", mainCategoryId);
      formData.append("subCategoryName", subCategoryName);
      formData.append("subCategoryBanner", subCategoryBanner);
      formData.append("subCategoryImage", subCategoryImage);
      formData.append("description", description);
      const path = isEdit
        ? `/sub-category/edit/${isEdit._id}`
        : "/sub-category/createSubCategory";

      const { res, err } = await httpRequest<any>({
        method: isEdit ? "put" : "post",
        path,
        params: formData,
        header: { "Content-Type": "multipart/form-data" },
      });
      if (res) {
        toast(`Sub category ${isEdit ? "updated" : "added"} successfully.`, {
          type: "success",
        });
        onSuccess();
      } else {
        toast(err, { type: "error" });
      }
      setIsLoader(false);
    }
  };

  useEffect(() => {
    if (isEdit && typeof isEdit !== null) {
      let {
        mainCategoryId = "",
        subCategoryName = "",
        subCategoryBanner = "",
        subCategoryImage = "",
        description = "",
      } = isEdit;
      setPayload({
        mainCategoryId,
        subCategoryName,
        subCategoryBanner,
        subCategoryImage,
        description,
      });
    }
  }, [isEdit]);

  return (
    <div className="table-container">
      <div className="admin-create-role-main">
        <div className="admin-create-role">
          <div className="create-operators-res">
            <div>
              <h3 className="font-size-18px text-[#2F2F31] mb-1 font-Poppins-Regular">
                <span className="text-[#FF0000]">* </span> Sub Categories Banner Image
              </h3>
              <ImageUpload
                image={payload?.subCategoryBanner}
                onImageChange={(file: File | null) =>
                  setPayload((prev) => ({ ...prev, subCategoryBanner: file }))
                }
                labelId="sub-category-banner-input"
                extraClasses={"w-full"}
              />
            </div>
            <div>
              <h3 className="font-size-18px text-[#2F2F31] mb-1 font-Poppins-Regular">
                <span className="text-[#FF0000]">* </span> Categories Image
              </h3>
              <ImageUpload
                image={payload?.subCategoryImage}
                onImageChange={(file: File | null) =>
                  setPayload((prev) => ({ ...prev, subCategoryImage: file }))
                }
                labelId="sub-category-image-input"
              />
            </div>
            {/* <SelectDropdown
              loader={getLoader}
              options={allMainCategory}
              isMulti={false}
              data={allMainCategory.filter(
                (v) => v?.value === payload?.mainCategoryId
              )}
              setData={(e) =>
                setPayload((prev) => ({
                  ...prev,
                  mainCategoryId: e[0]?.value || "",
                }))
              }
              checkboxShow={false}
              isLabel={true}
              labelText="Main Category"
              isRequired={true}
              id="sub-category-name-input"
            /> */}

            <CustomWebsiteDropdown
              options={allMainCategory}
              data={allMainCategory.filter(
                (v) => v?.value === payload?.mainCategoryId
              )}
              // loading={getLoader}
              setData={(e) =>
                setPayload((prev) => ({
                  ...prev,
                  mainCategoryId: e[0]?.value || "",
                }))
              }
              labelText="Main Category"
              isRequired={true}
              dropdownMainId="main-category-dropdown"
              clearId="main-cat"
              optionId={(v: Option, index) =>
                `main-category-option-${index + 1}`
              }
            />

            <SimpleInput
              value={payload?.subCategoryName}
              onChange={(val: string) => {
                let filteredValue = val.replace(/[^a-zA-Z0-9\s]/g, "");
                setPayload((prev) => ({
                  ...prev,
                  subCategoryName: filteredValue,
                }));
              }}
              isLabel={true}
              labelText="Category Name"
              isRequired={true}
              id="sub-category-name-input"
              maxLength={40}
            />
            <SimpleInput
              value={payload?.description}
              onChange={(val: string) =>
                setPayload((prev) => ({ ...prev, description: val }))
              }
              isLabel={true}
              labelText="Description"
              type="textArea"
              isRequired={true}
              isLimit={500}
              maxLength={500}
              rows={5}
              id="description-input"
            />
          </div>
        </div>
        <div className="flex justify-end my-6">
          <PrimaryBtn
            loader={isLoader}
            ButtonText="Save"
            btnExtraStyle={{
              backgroundColor: "#00443f",
              borderRadius: "1.5rem",
            }}
            onPress={handleSubmit}
            id="save-sub-category-btn"
          />
        </div>
      </div>
    </div>
  );
};

export default UpsertSubCategory;
